import React from 'react';

type Props = {
  className?: string;
};

const PenIcon: React.FC<Props> = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
    <g>
      <mask
        id="mask0_1984_6785"
        style={{ maskType: 'alpha' }}
        width="24"
        height="24"
        x="0"
        y="0"
        maskUnits="userSpaceOnUse"
      >
        <path fill="#D9D9D9" d="M0 0H24V24H0z"></path>
      </mask>
      <g mask="url(#mask0_1984_6785)">
        <path
          fill="#000"
          d="M6.192 20.308a4.107 4.107 0 01-1.697-.377 4.066 4.066 0 01-1.399-1.008c.382-.109.744-.34 1.085-.695.34-.355.511-.828.511-1.42 0-.699.242-1.29.726-1.774a2.413 2.413 0 011.774-.726c.699 0 1.29.242 1.774.726s.726 1.075.726 1.774c0 .962-.342 1.786-1.028 2.471-.685.686-1.51 1.029-2.472 1.029zm0-1.5c.55 0 1.021-.196 1.413-.588.391-.392.587-.862.587-1.412a.967.967 0 00-.287-.713.967.967 0 00-.713-.287.967.967 0 00-.712.287.967.967 0 00-.288.713c0 .383-.046.733-.137 1.05a4.73 4.73 0 01-.363.9.67.67 0 00.25.05h.25zM11.5 14.75l-2.23-2.23 8.565-8.566a.977.977 0 01.687-.288.93.93 0 01.713.288l.83.83c.2.2.3.434.3.7 0 .267-.1.5-.3.7L11.5 14.75z"
        ></path>
      </g>
    </g>
  </svg>
);

export default PenIcon;
